module.exports = __webpack_public_path__ + "img/dm_blogi.68fbcdc8.jpg";